// extracted by mini-css-extract-plugin
export default {"root":"Loading_root__ZkCsi","part":"Loading_part__4I+Dz","lds-ring":"Loading_lds-ring__+k6-4"};